(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-einblick"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nc-offer-preview')) {
  customElements.define('nc-offer-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.stage = this.querySelector('[data-nci-stage]');
      this.status = this.querySelector('[data-nci-status]');
      if (!this.stage) return;
      this.records = [...this.querySelectorAll('[data-nci-item]')].flatMap(item => {
        const panel = item.querySelector('[data-nci-media]');
        if (!panel) return [];
        const title = item.querySelector('.nci__title');
        const labelText = title?.textContent.trim() || panel.dataset.nciLabel;
        let copy = item.querySelector('.nci__copy');
        const generated = !copy;
        if (!copy) {
          copy = document.createElement('div');
          copy.className = 'nci__copy';
          const label = document.createElement('span');
          label.className = 'nci__title h4';
          label.textContent = labelText;
          copy.appendChild(label);
          item.appendChild(copy);
        }
        let button = copy.querySelector('[data-nci-select]');
        if (!button) {
          button = document.createElement('button');
          button.className = 'nci__select';
          button.type = 'button';
          button.setAttribute('data-nci-select', '');
          button.setAttribute('aria-label', labelText + ' – Vorschau anzeigen');
          button.setAttribute('aria-controls', panel.id);
          copy.appendChild(button);
        }
        button.hidden = true;
        const anchor = document.createComment('NC Medienposition');
        item.insertBefore(anchor, panel);
        return [{ item, panel, button, copy, anchor, generated, label:labelText }];
      });
      if (!this.records.length) return;
      this.active = this.records[0];
      this.desktop = window.matchMedia('(min-width:990px)');
      const signal = this.controller.signal;
      this.desktop.addEventListener('change', () => this.setMode(), { signal });
      this.addEventListener('click', event => {
        const record = this.records.find(entry => entry.button === event.target.closest('[data-nci-select]'));
        if (this.enhanced && record) this.select(record);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (!this.enhanced) return;
        const index = this.records.findIndex(entry => entry.button === event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.records.length;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.records.length) % this.records.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.records.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.records[next]);
        this.records[next].button.focus();
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const record = this.records.find(entry => entry.item.dataset.blockId === event.detail.blockId);
        if (!record) return;
        this.active = record;
        if (this.enhanced) this.select(record, false);
      }, { signal });
      this.setMode();
    }
    stop(panel) {
      panel.querySelectorAll('video').forEach(video => video.pause());
      panel.querySelectorAll('iframe').forEach(frame => {
        if (!frame.hasAttribute('src')) return;
        frame.dataset.nciSrc = frame.getAttribute('src');
        frame.removeAttribute('src');
      });
    }
    restore(panel) {
      panel.querySelectorAll('iframe').forEach(frame => {
        if (frame.dataset.nciSrc && !frame.hasAttribute('src')) frame.setAttribute('src', frame.dataset.nciSrc);
      });
    }
    select(record, announce = true) {
      this.active = record;
      this.setAttribute('data-nci-media-align', record.panel.dataset.nciAlign === 'center' ? 'center' : 'start');
      this.records.forEach(entry => {
        const selected = entry === record;
        if (!selected) this.stop(entry.panel);
        entry.panel.hidden = !selected;
        entry.button.setAttribute('aria-pressed', String(selected));
        entry.item.toggleAttribute('data-nci-active', selected);
        if (selected) this.restore(entry.panel);
      });
      if (announce && this.status) this.status.textContent = 'Vorschau: ' + record.label;
    }
    setMode() {
      this.records.forEach(entry => this.stop(entry.panel));
      this.enhanced = this.desktop.matches;
      this.toggleAttribute('data-nci-enhanced', this.enhanced);
      this.stage.hidden = !this.enhanced;
      this.records.forEach(entry => {
        if (this.enhanced) this.stage.appendChild(entry.panel);
        else entry.item.insertBefore(entry.panel, entry.anchor.nextSibling);
        entry.button.hidden = !this.enhanced;
        entry.copy.hidden = entry.generated && !this.enhanced;
        if (!this.enhanced) {
          entry.panel.hidden = false;
          entry.item.removeAttribute('data-nci-active');
          entry.button.setAttribute('aria-pressed', 'false');
          this.restore(entry.panel);
        }
      });
      if (this.enhanced) this.select(this.active, false);
      else {
        this.removeAttribute('data-nci-media-align');
        if (this.status) this.status.textContent = '';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.records?.forEach(entry => {
        this.stop(entry.panel);
        entry.item.insertBefore(entry.panel, entry.anchor.nextSibling);
        entry.panel.hidden = false;
        entry.button.hidden = true;
        entry.item.removeAttribute('data-nci-active');
        this.restore(entry.panel);
        if (entry.generated) entry.copy.remove();
        entry.anchor.remove();
      });
      this.removeAttribute('data-nci-enhanced');
      this.removeAttribute('data-nci-media-align');
      if (this.stage) this.stage.hidden = true;
      if (this.status) this.status.textContent = '';
      this.enhanced = false;
      this.records = [];
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-faq-section')) {
    customElements.define('nc-faq-section', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode) return;
        this.onBlockSelect = (event) => {
          const item = event.target.closest('.ncf__item');
          if (item && this.contains(item)) item.open = true;
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-hero-background')) {
    customElements.define('nc-hero-background', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.refresh = () => {
          const out = this.querySelector('div'), template = this.querySelector('template');
          out?.querySelector('video')?.pause(); out?.replaceChildren();
          if (!this.motion.matches && out && template) { out.append(template.content.cloneNode(true)); const video = out.querySelector('video'); if (video) { video.muted = true; video.play()?.catch(() => {}); } }
        };
        this.motion.addEventListener('change', this.refresh); this.refresh();
      }
      disconnectedCallback() { this.motion?.removeEventListener('change', this.refresh); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-participant-stories')) {
    customElements.define('nc-participant-stories', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-nct-track]');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('[data-nct-card]')];
        this.controls = this.querySelector('[data-nct-controls]');
        this.position = this.querySelector('[data-nct-position]');
        this.buttons = [...this.querySelectorAll('[data-nct-step]')];
        this.dialog = this.querySelector('[data-nct-dialog]');
        this.dialogBody = this.querySelector('[data-nct-dialog-body]');
        this.dialogTitle = this.querySelector('[data-nct-dialog-title]');
        this.closeButton = this.querySelector('[data-nct-close]');
        this.mobile = window.matchMedia('(max-width:749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        };
        this.track.addEventListener('scroll', schedule, { passive:true, signal });
        this.mobile.addEventListener('change', schedule, { signal });
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.track);
        this.addEventListener('click', event => this.onClick(event), { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.isCarousel) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = this.index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = this.index + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.maxIndex;
          if (next === undefined) return;
          event.preventDefault();
          this.goTo(next);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (this.isCarousel && index >= 0) this.goTo(index);
        }, { signal });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => this.releaseDialog(), { signal });
        if (typeof this.dialog.showModal === 'function') {
          this.querySelectorAll('[data-nct-proof]').forEach(link => link.setAttribute('aria-haspopup', 'dialog'));
        }
        this.sync();
      }
      get pageSize() { return this.mobile.matches ? 1 : 3; }
      get maxIndex() { return Math.max(0, this.cards.length - this.pageSize); }
      get isCarousel() { return this.cards.length > this.pageSize; }
      offset(card) {
        const track = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        const style = getComputedStyle(this.track);
        return style.direction === 'rtl'
          ? rect.right - track.right + parseFloat(style.paddingRight || 0)
          : rect.left - track.left - parseFloat(style.paddingLeft || 0);
      }
      sync() {
        if (!this.cards.length) return;
        this.index = 0;
        if (this.isCarousel) {
          this.cards.forEach((card, index) => {
            if (Math.abs(this.offset(card)) < Math.abs(this.offset(this.cards[this.index]))) this.index = index;
          });
        }
        this.index = Math.min(this.index, this.maxIndex);
        this.track.tabIndex = this.isCarousel ? 0 : -1;
        this.controls.hidden = !this.isCarousel;
        const range = this.pageSize === 1 ? `${this.index + 1}` : `${this.index + 1}–${Math.min(this.index + this.pageSize, this.cards.length)}`;
        const value = `${range} / ${this.cards.length}`;
        if (this.position.textContent !== value) this.position.textContent = value;
        this.buttons.forEach(button => {
          button.disabled = Number(button.dataset.nctStep) < 0 ? this.index === 0 : this.index === this.maxIndex;
        });
      }
      goTo(index) {
        if (!this.isCarousel) return;
        const card = this.cards[Math.max(0, Math.min(index, this.maxIndex))];
        this.track.scrollBy({ left:this.offset(card), behavior:this.reduced.matches ? 'instant' : 'smooth' });
      }
      onClick(event) {
        const target = event.target;
        if (target.closest('[data-nct-close]')) {
          this.dialog.close();
          return;
        }
        const step = target.closest('[data-nct-step]');
        if (step) {
          this.goTo(this.index + Number(step.dataset.nctStep));
          return;
        }
        if (target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          return;
        }
        const link = target.closest('[data-nct-proof]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0 || typeof this.dialog.showModal !== 'function') return;
        const template = link.nextElementSibling;
        if (!template?.matches('template[data-nct-image]')) return;
        event.preventDefault();
        this.returnFocus = link;
        this.dialogTitle.textContent = link.dataset.nctTitle;
        this.dialogBody.replaceChildren(template.content.cloneNode(true));
        if (!this.dialog.open) {
          const style = document.documentElement.style;
          this.previousOverflow = [style.getPropertyValue('overflow'), style.getPropertyPriority('overflow')];
          style.setProperty('overflow', 'hidden');
          this.dialog.showModal();
        }
        this.closeButton.focus({ preventScroll:true });
      }
      releaseDialog() {
        if (this.previousOverflow) {
          const [value, priority] = this.previousOverflow;
          const style = document.documentElement.style;
          if (value) style.setProperty('overflow', value, priority);
          else style.removeProperty('overflow');
          this.previousOverflow = null;
        }
        this.dialogBody?.replaceChildren();
        if (this.isConnected && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll:true });
        this.returnFocus = null;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.releaseDialog();
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
